import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';

export function useGetStripeCheckoutGq(
  command: CommandGq,
  options?: QueryHookOptions<GQLData, GQLVariables>
) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
    ...options,
  });

  return {
    query,
    status: query.data?.users?.getStripeCheckout?.status ?? null,
  };
}

const gqTag = gql`
  query GetStripeCheckout($command: GetStripeCheckoutCommand!) {
    users {
      getStripeCheckout(command: $command) {
        status
      }
    }
  }
`;

interface GQLData {
  readonly users: {
    readonly getStripeCheckout: {
      readonly status: string;
    };
  };
}

export interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  stripeCheckoutId: string;
}
